import { createStore } from "redux";

import createReducers, { initialState } from "./reducers";

import asyncReducers from "data/async-reducers";
import composedMiddleware from "data/middleware";

const setInitialState = (props) => {
  const { entity, assets, user, launcher } = props;

  const initial = {
    entity: initialState.entity.merge(entity),
    assets: initialState.assets.merge(assets),
    user: initialState.user.merge(user),
    launcher: initialState.launcher.merge(launcher),
  };

  return initial;
};

export default (props) => {
  const initialState = setInitialState(props);
  const store = createStore(createReducers(), initialState, composedMiddleware());

  const enhancedStore = asyncReducers(store, createReducers);

  return enhancedStore;
};
